var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-inline-flex flex-wrap ga-2",
      attrs: { "data-qa": "contacts-item-messengers" },
    },
    _vm._l(_vm.messengers, function (messenger) {
      return _c("div", { key: messenger.id }, [
        messenger.messenger_type === "whatsapp"
          ? _c(
              "a",
              {
                staticClass:
                  "whatsapp-button px-4 py-3 rounded text-decoration-none d-flex align-center",
                attrs: {
                  href: `https://wa.me/${messenger.username}`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
              },
              [
                _c("img", {
                  staticClass: "mr-2",
                  attrs: {
                    src: "/static/_v1/pd/icons/socials/whatsapp-white.svg",
                    width: "20",
                    height: "20",
                    alt: `${_setup.t("Иконка", _setup.options)} WhatsApp`,
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "bg-gray-0--text text-button" }, [
                  _vm._v("\n        WhatsApp\n      "),
                ]),
              ]
            )
          : messenger.messenger_type === "telegram"
          ? _c(
              "a",
              {
                staticClass:
                  "tg-button px-4 py-3 rounded text-decoration-none d-flex align-center",
                attrs: {
                  href: `https://t.me/${messenger.username}`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
              },
              [
                _c("img", {
                  staticClass: "mr-2",
                  attrs: {
                    src: "/static/_v1/pd/icons/socials/tg-white.svg",
                    width: "20",
                    height: "20",
                    alt: `${_setup.t("Иконка", _setup.options)} Telegram`,
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "bg-gray-0--text text-button" }, [
                  _vm._v("\n        Telegram\n      "),
                ]),
              ]
            )
          : messenger.messenger_type === "max"
          ? _c(
              "a",
              {
                staticClass:
                  "max-button px-4 py-3 rounded text-decoration-none d-flex align-center",
                attrs: {
                  href: `https://max.ru/${messenger.username}`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
              },
              [
                _c("img", {
                  staticClass: "mr-2",
                  attrs: {
                    src: "/static/_v1/pd/icons/socials/max-white.svg",
                    width: "20",
                    height: "20",
                    alt: `${_setup.t("Иконка", _setup.options)} Max`,
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "bg-gray-0--text text-button" }, [
                  _vm._v("\n        Max\n      "),
                ]),
              ]
            )
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }